import React, { useContext, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import UserContext from "../../context/UserContext";
import "./SidebarFacility.scss";

function SidebarFacility() {
  const navigate = useNavigate();
  const location = useLocation();
  const { userDetail } = useContext(UserContext);

  const handleLogout = () => {
    window.localStorage.removeItem("access_token");
    window.localStorage.removeItem("flag");
    navigate("/login");
    window.location.reload();
  };

  return (
    <div className="sidebarMain">
      <div className="topLogo">
        <div className="centerLogo" onClick={() => navigate("/")}>
          <div className="logo"></div>
          <div className="name"></div>
        </div>
      </div>
      <div className="listMain">
        <div className="listMainSec">
          <div className="sidebarList">
            <a
              href="/facility/dashboard"
              style={{
                color: location.pathname.includes("/facility/dashboard")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Dashboard
            </a>
            <a
              href="/facility/details"
              style={{
                color: location.pathname.includes("/facility/details")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Facility
            </a>
            <a
              href="/facility/schedule"
              style={{
                color: location.pathname.includes("/facility/schedule")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Schedule
            </a>
            <a
              href="/facility/allbookings"
              style={{
                color: location.pathname.includes("/facility/allbookings")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              All Bookings
            </a>
            {/* {showPortfolio && ( */}
            {/* )} */}
            {/* <a
              href="/dashboard/myContribution"
              style={{
                color: location.pathname.includes("/dashboard/myContribution")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              My Contributions
            </a> */}
          </div>
          <div className="sidebarListSec">
            {/* <a
              href="/dashboard/KYC"
              style={{
                color: location.pathname.includes("/dashboard/KYC")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              My KYC
            </a> */}
            <div className="helpAndSupport">
              <a
                href="/facility/updatePassword"
                style={{
                  color: location.pathname.includes("/facility/updatePassword")
                    ? "#FFBF00"
                    : "inherit",
                }}
              >
                Update Password
              </a>
            </div>
            <a
              href="/facility/support"
              style={{
                color: location.pathname.includes("/facility/support")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Contact Us
            </a>
            <a href="/" onClick={handleLogout}>
              Logout
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SidebarFacility;
